import { put, call, all } from "redux-saga/effects";
import { reportError, reportSuccess } from "../actions/erroractions";
import { saveEvidenceFailure, saveEvidenceSuccess } from "../actions/songactions";
import { saveEvidenceAPI } from "../api/SaveEvidenceCall";

export function* saveEvidenceSaga(action) {
    try {
        const result = yield call(saveEvidenceAPI, action);

        if (Object.hasOwn(result, "status") && result.status === 204) {
            yield all([
                put(saveEvidenceSuccess(action.uniqueName)),
                put(reportSuccess("Successfully saved evidence")),
            ]);
        } else {
            yield all([
                put(saveEvidenceFailure(action.uniqueName)),
                put(reportError(result.message))
            ]);
        }
    } catch(e) {
        yield all([
            put(saveEvidenceFailure()),
            put(reportError("Unable to reach server"))
        ]);
    }
}